// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vant from 'vant'
import components from './components/'
import * as echarts from 'echarts'


import './assets/scss/main.scss';

import methods from './util/addMethods';

import 'vant/lib/index.css';

import UI from './tool/ui.js';
import './tool/rem.js';
import moment from 'moment';
import md5 from 'js-md5';
import store from './store/all.store.js';


Vue.use(methods);
Vue.use(Vant);



Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$UI = new UI(Vue)
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
Vue.prototype.$md5 = md5

Object.keys(components).forEach(key => {
    var name = key.replace(/(\w)/, (v) => v.toUpperCase()); //首字母大写
    Vue.component(`v${name}`, components[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = null
// module chunks = 